customElements.define('cart-items', class CartItems extends HTMLElement {
  constructor() {
    super();
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'cart-outer',
        section: 'cart-items',
        selector: '.cart__cart-items'
      },
      {
        id: 'cart-outer',
        section: 'cart-summary',
        selector: '.cart__summary-outer'
      },
      {
        id: 'cart-drawer',
        section: 'cart-drawer-items',
        selector: '.cart__cart-items'
      },
      {
        id: 'cart-drawer',
        section: 'cart-footer',
        selector: '.cart-drawer__footer'
      },
      {
        id: 'nav-outer',
        section: 'cart-nav-icon',
        selector: '.header__utility-link--cart'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateQuantity(line, quantity, changeType, newProperties = {}) {
    this.querySelector('.cart-item__qty').classList.add('disabled');
    console.log(changeType)
    fetch("/cart/change.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            line: line,
            quantity: quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        })
    })
    .then(response => {
      if(response.ok) {
        return response.json();
      }
      throw new Error('Request Failed!');
    }, networkError => console.log(networkError.message)
    ).then((response) => {
      this.getSectionsToRender().forEach((section => {
        if (document.getElementById(section.id) != null && document.getElementById(section.id).querySelector(section.selector) != null || document.getElementById(section.id) != null) {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(response.sections[section.section], section.selector);
        }
      }))

      checkTCBox(document.querySelector('#termsbox_id'))

      // Call the function to log the output
      countBraidsDealItems();

      // Dispatch the custom event 'cartBuiltEvent'
      const cartBuiltEvent = new CustomEvent('cartBuiltEvent');
      if(changeType == 'qtyIncrease') {
        document.dispatchEvent(cartBuiltEvent);

        document.addEventListener('cartBuiltEvent', function() {
          let cartQtys = document.querySelectorAll('.cart-item__qty'),
          newQuantity = null;
          cartQtys.forEach(cartQty => {
            if(cartQty.dataset.index == line) {
              newQuantity = cartQty.querySelector('input').value;
            }
          });
          if(newQuantity <= quantity) {
            var quantityWarnings = document.querySelectorAll('.quantityWarningNoStock');
            for(i=0; i<quantityWarnings.length; i++) {
              quantityWarnings[i].style.opacity = 1;
              setTimeout(() => {
                var quantityWarnings = document.querySelectorAll('.quantityWarningNoStock');
                for(var o=0; o<quantityWarnings.length; o++) {
                  quantityWarnings[o].style.opacity = 0;
                }
              }, "2000");
            }
          }
        });
      }
    })
   .catch((e) => {
      this.querySelectorAll('.loader-container').forEach((loader) => {
        loader.classList.remove('loading');
      });
      console.error(e);
    })
  }
});

customElements.define('cart-remove-button', class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      var cartItems = this.closest('cart-items'),
      cartItem = this.closest('.cart-item');
      
      cartItems.classList.add('disabled');
      cartItem.querySelector('.loader-container').classList.add('loading');
      cartItems.updateQuantity(this.dataset.index, 0, {});

      cartItems.classList.remove('disabled');
    });
  }
});

customElements.define('cart-quantity', class CartQuantity extends HTMLElement {
  constructor() {
    super();
    this.querySelector('.quantity__input').addEventListener('change', (event) => {
      event.preventDefault();
      var cartItems = this.closest('cart-items'),
          cartItem = this.closest('.cart-item'),
          quantity = this.querySelector('.quantity__input').value;

      cartItems.classList.add('disabled');
      cartItem.querySelector('.loader-container').classList.add('loading');
      cartItems.updateQuantity(this.dataset.index, quantity, 'qtyRemove', {});

      cartItems.classList.remove('disabled');
    });
  }
});

customElements.define('quantity-decrease-button', class QuantityDecreaseButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      var cartItems = this.closest('cart-items'),
          cartItem = this.closest('.cart-item'),
          quantity = this.closest('.quantity__btn-container').querySelector('.quantity__input').value;
      
      cartItems.classList.add('disabled');
      cartItem.querySelector('.loader-container').classList.add('loading');
      if(quantity == 1)
        cartItems.updateQuantity(this.closest('cart-quantity').dataset.index, 0, 'qtyDecrease', {});
      else {
        cartItems.updateQuantity(this.closest('cart-quantity').dataset.index, quantity, 'qtyDecrease', {});
      }

      cartItems.classList.remove('disabled');
    });
  }
});

customElements.define('quantity-increase-button', class QuantityIncreaseButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();

      var cartItems = this.closest('cart-items'),
          cartItem = this.closest('.cart-item'),
          quantity = this.closest('.quantity__btn-container').querySelector('.quantity__input').value;
      
      cartItems.classList.add('disabled');
      cartItem.querySelector('.loader-container').classList.add('loading');
      cartItems.updateQuantity(this.closest('cart-quantity').dataset.index, quantity, 'qtyIncrease', {});

      cartItems.classList.remove('disabled');
    });
  }
});